import { render, staticRenderFns } from "./DetailedSale.vue?vue&type=template&id=784f505e&scoped=true&"
import script from "./DetailedSale.vue?vue&type=script&lang=js&"
export * from "./DetailedSale.vue?vue&type=script&lang=js&"
import style0 from "./DetailedSale.vue?vue&type=style&index=0&lang=css&"
import style1 from "./DetailedSale.vue?vue&type=style&index=1&id=784f505e&lang=scss&scoped=true&"
import style2 from "./DetailedSale.vue?vue&type=style&index=2&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "784f505e",
  null
  
)

export default component.exports